import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ChannelsService } from '../../services/channels.service';
import { ProjectResponse } from '../../models';
import { PlaylistService } from '../../services/playlist.service';
import { UiService } from 'src/app/services/ui.service';

@Component({
	selector: 'app-watchlist',
	templateUrl: './watchlist.component.html',
	styleUrls: ['./watchlist.component.scss']
})
export class WatchlistComponent implements OnInit {
	media: Array<ProjectResponse> = [];
	isLoading: boolean = true;
    focusIndex = 0;
	displayComponent: any;

	@ViewChild('imageSlider') containerRef: ElementRef;

	constructor(private channelService: ChannelsService, private playlistService: PlaylistService) {
	}

	async ngOnInit(): Promise<void> {
		let res = await this.channelService.getUserChannels().toPromise().finally(() => {
			this.isLoading = false;
		});
		this.media = res.find(f => f.playlistId === 'my-watchlist')?.media;
		this.playlistService.mediaList = this.media;
        this.channelService.refreshWatchHistory();
	}

	recoverFocus(id: number) {
		let elementToFocus: HTMLElement | null = null;
		const videoThumbs = document.querySelectorAll('video-thumb-watchlist');

		// Prefer the previous video item if it exists.
		if (this.media[this.focusIndex - 1]) {
		  const previousIndex = this.focusIndex - 1;
		  const previousThumb = videoThumbs[previousIndex] as HTMLElement;
		  if (previousThumb) {
			elementToFocus = previousThumb.querySelector('div');
		  }
		}
		// If no previous item, try the next video item.
		else if (this.media[this.focusIndex + 1]) {
		  const nextIndex = this.focusIndex + 1;
		  const nextThumb = videoThumbs[nextIndex] as HTMLElement;
		  if (nextThumb) {
			elementToFocus = nextThumb.querySelector('div');
		  }
		}
		// If neither adjacent video exists, fall back to the watchlist sidebar item.
		if (!elementToFocus) {
		  const navItems = document.querySelectorAll('.nav-item');
		  if (navItems.length >= 2) {
			elementToFocus = navItems[navItems.length - 2] as HTMLElement;
		  }
		}
		console.log(elementToFocus);
		this.displayComponent = elementToFocus.outerHTML;
		console.log(elementToFocus);
		if (elementToFocus && typeof elementToFocus.focus === 'function') {
		  elementToFocus.focus();
		}
		this.playlistService.deleteFromLocal(id);
	}
}
